module.exports = __webpack_public_path__ + "img/login-register.0c8d643c.jpg";